import * as healthCheckTypes from "../types/healthCheckTypes";

const INITIAL_STATE = {
    userData: []
};

const healthCheckReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case healthCheckTypes.SET_USER_DATA:
            return { ...state, userData: action.payload };
        default:
            return state;
    }
};

export default healthCheckReducer;